// extracted by mini-css-extract-plugin
export default {"Icon":"LV6xXwg1","IconContainer":"BPq7fVu7","ButtonPlaceholder":"DvSaUABH","ButtonSkeleton":"JLcqfpNy","IconPlaceholder":"isYh_Xez","Label":"f4yH2UA4"};